<template>
    <div class="serve-container">
        <Nav :currentActive="'Serve'" />

        <div class="serve-banner">
            <div class="banner">
                <img src="@/assets/images/service-banner.png" />
            </div>
            <div class="banner-desc">
                <div class="banner-desc-text">
                    <div class="title">平台服务</div>
                    <div class="text">MID码是由MID服务平台授予的，基于区块链去中心化、数据不可篡改的技术特性，锁定产品生产加工、贸易流通等全生命周期信息的唯一数字身份标识。通过MID服务平台为产品赋码，形成“一物一码、一物一档”。</div>
                </div>
                
            </div>
        </div>
        <div class="service-desc pt110 pb110">
            <div class="contain">
                <div class="service-desc-content">
                    <div class="lft">
                        <div class="icon-out">
                            <div class="icon centered wow zoomIn" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: zoomIn;">
                                <div class="inner centered">
                                    <div class="logo centered">
                                        <img src="@/assets/images/service-desc-logo.png" class="full-maxAuto" ondragstart="return false"> 
                                    </div>
                                </div>
                            </div>
                            <ul>
                                <li class="top wow to-down" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                                    <div class="i centered">
                                        <img src="@/assets/images/service-desc-icon1.png" ondragstart="return false"> 
                                    </div>
                                    <div class="list">
                                        <p>
                                            平台+生态的发展理念
                                        </p>
                                        <p>
                                            提供一体化质量品牌服务
                                        </p>
                                    </div>
                                </li>
                                <li class="left wow to-rgt" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                                    <div class="i centered">
                                        <img src="@/assets/images/service-desc-icon2.png" ondragstart="return false"> 
                                    </div>
                                    <div class="list">
                                        <p>
                                            机构制定标准
                                        </p>
                                        <p>
                                            第三方提供检测
                                        </p>
                                        <p>
                                            企业加强赋码
                                        </p>
                                        <p>
                                            百姓主动扫码
                                        </p>
                                        <p>
                                            数据反馈企业
                                        </p>
                                    </div>
                                </li>
                                <li class="right wow to-lft" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                                    <div class="i centered">
                                        <img src="@/assets/images/service-desc-icon3.png" ondragstart="return false"> 
                                    </div>
                                    <div class="list">
                                        <p>
                                            质量管理
                                        </p>
                                        <p>
                                            政府监管
                                        </p>
                                        <p>
                                            企业运营
                                        </p>
                                        <p>
                                            第三方服务
                                        </p>
                                        <p>
                                            互联网舆情
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="rgt wow zoomIn" data-wow-delay="0.5s" style="visibility: visible; animation-delay: 0.5s; animation-name: zoomIn;">
                        <div class="com-tit fs34">
                            MID服务平台
                        </div>
                        <div class="text mt20">
                            <p>
                                MID服务平台是一个由融贯科技、澳门质量品牌国际认证联盟、中国信息通讯研究院、澳门城市大学、浪潮集团等共同打造的，基于工业互联网骨干节点的增强可信数据传递平台，面向粤港澳大湾区产业、贸易运营需求，提供标识注册和解析服务以及非侵入、悬挂式数据采集、跨链数据融合功能，实现了跨系统、跨企业、跨行业、跨地域的数据共享。
                            </p>
                            <p>
                                MID服务平台通过结合国家标识体系与区块链、国家商用密码技术，形成了基于“星火·链网”体系的MID码服务。利用区块链技术构建底层可信数据支撑体系，通过汇集质量管理、政府监管、企业运营、第三方服务以及互联网舆情等数据形成数据湖，以数据为支撑采用“平台+生态”的发展理念提供一体化质量品牌服务，并形成了机构制定标准、第三方提供检测、企业加强赋码、百姓主动扫码、数据反馈企业的“多方共治一体化”闭环运行模式，为高质量发展和品牌提升提供新动能，助力国家“质量强国”战略实施。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service-ind">
            <div class="container">
                <div class="com-tit">产业应用</div>
                <div class="service-ind-main">
                    <div class="side">
                        <a class="item" :class="mainIndex == 0 ? 'active' : ''" @click="mainIndex = 0;subIndex = 0;">
                            <i>
                                <img src="@/assets/images/service-ind-nav1-c.png" class="c" />
                                <img src="@/assets/images/service-ind-nav1-w.png" class="w" />
                            </i>
                            <div class="title">第一产业领域</div>
                        </a>
                        <a class="item" :class="mainIndex == 1 ? 'active' : ''" @click="mainIndex = 1;subIndex = 0;">
                            <i>
                                <img src="@/assets/images/service-ind-nav2-c.png" class="c" />
                                <img src="@/assets/images/service-ind-nav2-w.png" class="w" />
                            </i>
                            <div class="title">民生领域</div>
                        </a>
                        <a class="item" :class="mainIndex == 2 ? 'active' : ''" @click="mainIndex = 2;subIndex = 0;">
                            <i>
                                <img src="@/assets/images/service-ind-nav3-c.png" class="c" />
                                <img src="@/assets/images/service-ind-nav3-w.png" class="w" />
                            </i>
                            <div class="title">金融领域</div>
                        </a>
                    </div>
                    <div class="cont-list">
                        <div class="cont-item">
                            <div class="heading-title">{{ containerList[mainIndex].title }}</div>
                            <div class="heading-text">{{ containerList[mainIndex].desc }}</div>
                            <div class="cont-tab">
                                <a v-for="(item, index) in containerList[mainIndex].tabList" :key="index" :class="subIndex == index ? 'on' : ''"
                                    @click="subIndex = index">
                                    {{ item.name }}
                                </a>
                                <div class="cont-txt">
                                    <div class="sub-txt">
                                        <div class="in">
                                            <p>{{ containerList[mainIndex].tabList[subIndex].desc }}</p>
                                            <br/>
                                            <img v-for="(img, imgIndex) in containerList[mainIndex].tabList[subIndex].imgs" :src="img" :key="imgIndex" />
                                            <p v-if="containerList[mainIndex].tabList[subIndex].desc2">{{ containerList[mainIndex].tabList[subIndex].desc2 }}</p>
                                            <p v-if="containerList[mainIndex].tabList[subIndex].desc3">{{ containerList[mainIndex].tabList[subIndex].desc3 }}</p>
                                            <p v-if="containerList[mainIndex].tabList[subIndex].desc4">{{ containerList[mainIndex].tabList[subIndex].desc4 }}</p>
                                            <p v-if="containerList[mainIndex].tabList[subIndex].desc5">{{ containerList[mainIndex].tabList[subIndex].desc5 }}</p>
                                            <p v-if="containerList[mainIndex].tabList[subIndex].desc6">{{ containerList[mainIndex].tabList[subIndex].desc6 }}</p>
                                        </div>
                                    </div>
                                    <div class="cont-sub-list" v-if="containerList[mainIndex].tabList[subIndex].contentList && containerList[mainIndex].tabList[subIndex].contentList.length > 0">
                                        <div class="cont-sub-item" v-for="(cont, contIndex) in containerList[mainIndex].tabList[subIndex].contentList" :key="contIndex">
                                            <div class="icon">
                                                <img :src="cont.icon" />
                                            </div>
                                            <div class="title">{{ cont.title }}</div>
                                            <div class="content">
                                                <p>{{ cont.content }}</p>
                                            </div>
                                        </div>
                                        <div v-if="containerList[mainIndex].tabList[subIndex].contentList.length % 3 > 1" class="cont-sub-item"></div>
                                        <div v-if="containerList[mainIndex].tabList[subIndex].contentList.length % 3 > 2" class="cont-sub-item"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
        </div>
        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  
  const startAnimate = ref(false)

  const mainIndex = ref(0)
  const subIndex = ref(0)
  

  const containerList = ref([
    {
        title: '第一产业领域',
        desc: '公众难以区分产品品质差异，不清楚产品产地来源，尤其是在以中医药、茶叶为代表的第一产业领域。随着社会生产生活节奏的加快、信息化和网络化的普及，生产者“各自为政”的信息化系统共享出来的数据有限或没有，难以满足消费者希望了解全生产过程的需求。',
        tabList: [
            {
                name: '中医药全产业链',
                desc: '在中医药产业，“星火·链网”（珠海横琴）骨干节点利用区块链+标识解析技术，依托中药质量研究国家重点实验室授权认证，通过BID搭建中医药全产业链体系，涵盖中药材可追溯体系、实现监管标准化、添加中药材分级认证信息，为中草药提供可信数据网络和平台，实现来源可知、去向可踪、质量可控、责任可究，促进中医药产业化、国际化发展。',
                imgs: [
                    require('@/assets/images/serve-01.jpg')
                ],
                contentList: [
                    {
                        title: '中药材追溯体系',
                        icon: require('@/assets/images/service-desc-icon1.png'),
                        content: '采集中药材生产种植、加工包装、运输流通、交易、消费者使用等各个环节的原始信息数据，通过区块链上传到追溯平台保证其信息真实。同时赋予产品唯一的“MID码”，消费者可通过扫描“MID码”获得该中药材全生命周期信息，实现涵盖中药材种植标准化、制程标准化、运输流通标准化的中药材追溯体系。',
                    },
                    {
                        title: '监管标准化',
                        icon: require('@/assets/images/service-desc-icon2.png'),
                        content: '根据地方管理部门制定的该地区可溯源产品名录，汇总在追溯平台，明确对应中药材责任主体，方便市场监督部门监管。市场监督部门可对于市场所出现的产品问题，通过对消费者的走访调查和信息采集，精准定位问责对象，并将不良反应案例在平台进行公告。',
                    },
                    {
                        title: '分级认证信息',
                        icon: require('@/assets/images/service-desc-icon3.png'),
                        content: '中医药行业国际化发展需要统一质量标准，通过联合检验检测组织、认证组织、中药质量研究国家重点实验室（澳门科技大学）等单位，规范生产工艺，制定中药材品质分级标准，同时加强产品的药效对比及药物经济学研究，确保疗效，提高国际竞争力。',
                    },
                ]
            },
            {
                name: '茶叶子链',
                desc: '基于骨干节点技术在茶叶产业搭建茶叶子链，实现数据无缝衔接，打造茶叶产品全生命周期可信数据体系，实现种植、交易、贮存、远期交割、数字交易等全产业链数据锚定与查询。',
                desc2: '数字交易存证服务：用于茶叶溯源中的数据区块链骨干节点的交易验证规则。所有的交易都必须依据背书策略进行交易，只有经过节点处理的交易才是合法、被认可的交易。',
                desc3: '以“MID码”溯源服务平台支撑，面向企业提供供应链管理服务，提升企业数字化管理能力；面向政府监管部门，提供产品订单、质量溯源、检验检测、报关通关等跨境贸易流通关键环节数据，支撑贸易便利化通关服务。',
                imgs: [
                    require('@/assets/images/serve-02.jpg')
                ],
                contentList: [
                    {
                        title: '加工与检测数据相融合',
                        icon: require('@/assets/images/service-desc-icon1.png'),
                        content: '加工企业通过标识直接调用相关产品生产标准，利用物联网技术实现全流程数据传递与记录，第三方检验检测机构通过产品标识可直接获取产品生产过程中的检测数据，实现异地数据复核与产品认证。',
                    },
                    {
                        title: '产品流通数据全程记录',
                        icon: require('@/assets/images/service-desc-icon2.png'),
                        content: '产品出库后，通过标识记录产品物流全流程信息以及消费者购买信息系，消费者可通过标识，解析产品全流程数据，查验产品真伪和检验情况，通过区块链，确认数据是否可信。',
                    },
                ]
            }
        ],
    },
    {
        title: '民生领域',
        desc: '目前，粤港澳大湾区“硬联通”能力提升效果显著，但由于粤澳两地现有的法律、法规、福利制度等规则制度存在差异，粤澳两地亟需进一步推进有利于创新跨境流动和规则制度的“软联通”。',
        tabList: [
            {
                name: '大湾区学历互认',
                desc: '基于BID标识的学历管理平台，企业验证求职者学历更便捷，节约求职者及企业验证时间成本；求职者个人信息需授权可见，保障了信息安全，隐私不泄露；学历信息上链后难以篡改，保障了信息权责明确。“星火·链网”骨干节点（珠海横琴）搭建的学历认证平台使得价值信息在身份标识BID之间进行流转。',
                imgs: [
                    require('@/assets/images/serve-03.jpg')
                ],
                contentList: null,
            },
            {
                name: '澳门电子医疗券',
                desc: '将药房、医院、私人医生、卫健部门等医疗相关单位纳入骨干节点业务子链节点，使“医疗券”的使用全部记录在案，患者与医疗机构均有迹可循。不仅能有效杜绝“医疗券”的滥用，解决澳门医疗痛点；亦可使澳门卫生局合理分配医疗资源，让“医疗券”计划重回造福澳门居民的初衷。',
                desc2: '● 注册居民个人标识：一人一码（“MID码”），根据个人标识进行“医疗券”派发；',
                desc3: '● 居民激活个人标识：居民与标识绑定，并备案相关健康信息；',
                desc4: '● 医疗提供方纳入节点：将医院、私人医生等医疗提供方纳入节点，可通过解析居民个人标识查看健康信息，同时将此次就医情况信息上传节点存档；',
                desc5: '● 药房接入系统：通过对比居民健康档案，保证居民药物购买增添保障，同时记录此次购买记录；如需使用“医疗券”必须经过节点处理验证，并记录“医疗券”核销情况；',
                desc6: '● 政府监管：澳门政府可通过节点查看“医疗券”使用信息及居民健康情况，宏观掌控辖区内医疗资源，为医疗领域重点发展决策提供数据支撑。',
                imgs: [
                    require('@/assets/images/serve-04.jpg'),
                    require('@/assets/images/serve-05.jpg'),
                ],
                contentList: null
            }
        ],
    },
    {
        title: '金融领域',
        desc: '大湾区金融基础良好，且体量大，但粤港澳三地金融业相互之间的开放程度不足，金融机构互设存在一些障碍，阻碍着三地之间金融业的合作与发展，先进技术及基础设施是大湾区金融互联互通的首要条件。',
        tabList: [
            {
                name: '金融服务链',
                desc: '“星火·链网”（珠海横琴）骨干节点利用区块链的技术，可以直接实现对称的价值传递、端到端透明化，将所有纸质工作升级为程序数字化，不需要特定的实物票据证明，同时也可以通过区块链技术分析和监测承租人交易行为的异常状态，及时发现并消除欺诈行为。既减少了人工成本的投入，也提高了交易的安全度和可控性。',
                imgs: [
                    require('@/assets/images/serve-06.jpg')
                ],
                contentList: null
            },
        ],
    }
  ])

  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .serve-container {
    padding-top: 84px;
 }

 .serve-banner {
    position: relative;
 }
 .serve-banner .banner {
    width: 100%;
 }
 .serve-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .serve-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .serve-banner .banner-desc .title {
    font-size: 30px;
 }
 .serve-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }

 .service-desc {
    padding: 90px 0;
 }
    .contain {
        margin: 0 auto;
        width: 1200px;
    }
    .service-desc-content {
        display: flex;
        border: 1px dashed #eeeeee;
    }
    .service-desc-content .lft {
        width: 50%;
        text-align: center;
        padding-top: 144px;
    }
    .service-desc-content .lft .icon-out {
        position: relative;
        margin: 0 auto;
        display: inline-block;
    }
    .service-desc-content .lft .icon {
        width: 238px;
        height: 238px;
        border-radius: 50%;
        border: 1px solid #2c72d6;
        padding: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .service-desc-content .lft .icon .inner {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid rgba(44, 114, 214, 0.46);
        background: url(../../assets/images/service-desc-bg.png) no-repeat center / cover;
        padding: 28px;
    }
    .service-desc-content .lft .icon .logo {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #2c72d6;
    }
    .centered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .service-desc-content .lft ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .service-desc-content .lft li.top {
        flex-direction: column-reverse;
        align-items: center;
        width: 100%;
        left: 0;
        top: -36%;
    }
    .service-desc-content .lft li.top .i {
        margin-top: 12px;
    }

    .service-desc-content .lft li.left {
        flex-direction: row-reverse;
        left: -90%;
        bottom: 4%;
    }
    .service-desc-content .lft li.left .i {
        margin: 50px 0 0 10px;
    }
    .service-desc-content .lft li.left p {
        padding-left: 0;
        padding-right: 18px;
        text-align: right;
    }
    .service-desc-content .lft li.left p:after {
        left: auto;
        right: 0;
    }
    
    .service-desc-content .lft li.right {
        right: -90%;
        bottom: 4%;
    }
    .service-desc-content .lft li.right .i {
        margin: 50px 10px 0 0;
    }

    .service-desc-content .lft li {
        display: flex;
        position: absolute;
    }
    .service-desc-content .lft li .i {
        width: 52px;
        min-width: 52px;
        height: 52px;
        border-radius: 50%;
        border: 1px solid #2c72d6;
        background: #fff;
    }
    .service-desc-content .lft li .list {
        width: 200px;
    }
    .service-desc-content .lft li p {
        font-size: 15px;
        line-height: 22px;
        color: #444444;
        position: relative;
        padding-left: 18px;
        padding-right: 10px;
        text-align: left;
        margin: 0;
    }
    .service-desc-content .lft li p:after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 1px solid #2c72d6;
        position: absolute;
        left: 0;
        top: 8px;
    }
    


    .service-desc-content .rgt {
        width: 50%;
        padding: 50px 40px;
        border-left: 1px dashed #eeeeee;
        position: relative;
        z-index: 1;
    }
    .com-tit {
        color: #333333;
        font-weight: 500;
        line-height: 1.1;
        font-size: 28px;
    }
    .service-desc-content .rgt .text {
        font-size: 15px;
        line-height: 26px;
        color: #777777;
        margin-top: 18px;
    }
    .service-desc-content .rgt:after {
        content: '';
        background: url(@/assets/images/service-desc--txt-bg.png) no-repeat center / 100%;
        width: 450px;
        height: 360px;
        left: 50%;
        top: calc(50% + 10px);
        transform: translate(-50%, -50%);
        position: absolute;
        z-index: -1;
    }
    * {
        box-sizing: border-box;
    }

    .service-ind {
        background: #f2f4f8;
        position: relative;
        overflow: hidden;
        padding: 90px 0;
    }
    .service-ind .container {
        position: relative;
        z-index: 10;
        margin: 0 auto;
        width: 1200px;
    }
    .service-ind .container .com-tit {
        color: #333333;
        font-weight: 500;
        line-height: 1.1;
        font-size: 28px;
        text-align: center;
    }
    .service-ind-main {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .service-ind-main .side {
        width: 21%;
    }
    .service-ind-main .side .item {
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: #fff;
        border: 1px solid #ededed;
        transition: background-color .4s ease, border .4s ease;
    }
    .service-ind-main .side .item i {
        transition: transform .4s ease;
    }
    .service-ind-main .side .item:hover i {
        transform: scale(0.94);
    }
    .service-ind-main .side .item.active:hover i {
        transform: scale(1);
    }
    .service-ind-main .side .item.active {
        background: #2970d6;
        border-color: #2970d6;
    }
    .service-ind-main .side .item.active i .c {
        display: none;
    }
    .service-ind-main .side .item.active i .w {
        display: block;
    }
    .service-ind-main .side .item i .c {
        display: block;
    }
    .service-ind-main .side .item i .w {
        display: none;
    }
    .service-ind-main .side .item .title {
        font-size: 16px;
        font-weight: 500;
        margin-top: 8px;
        transition: all .4s ease;
    }
    .service-ind-main .side .item.active .title {
        color: #fff;
    }
    .cont-list {
        background: #fff;
        border-radius: 4px;
        width: 76%;
        padding: 50px 40px 80px;
    }
    .cont-list .cont-item {

    }
    .cont-list .cont-item .heading-title {
        color: #333333;
        font-weight: 500;
        font-size: 20px;
    }
    .cont-list .cont-item .heading-text {

        letter-spacing: .04em;
        margin-top: 16px;
        font-size: 15px;
        line-height: 26px;
        color: #777777;
    }
    .cont-list .cont-item .cont-tab {
        display: flex;
        flex-wrap: wrap;
        margin-top: 24px;
        
    }
    .cont-list .cont-item .cont-tab a {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #444444;
        font-size: 17px;
        box-shadow: inset 0 0 0 1px #f2f4f8;
        font-weight: 500;
        transition: all .4s ease;
        position: relative;
        overflow: hidden;
        z-index: 2;
        width: 250px;
        padding: 14px 0;
    }
    .service-ind-main .cont-list .cont-tab a:not(.on):hover, .service-ind-main .cont-list .cont-tab a.on {
        color: #2970d6;
    }

    .service-ind-main .cont-list .cont-tab a:before {
        content: '';
        width: 0;
        height: 100%;
        position: absolute;
        left: 100%;
        top: 0;
        background: #f2f4f8;
        transition: all .4s ease;
        z-index: -1;
        opacity: 0;
    }
    .service-ind-main .cont-list .cont-tab a.on:before {
        width: 100%;
        opacity: 1;
        left: 0;
    }
    .service-ind-main .cont-list .cont-tab a:after {
        content: '';
        width: 4px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: #2970d6;
        opacity: 0;
        transform: translateX(-100%);
        transition: all .4s ease .1s;
    }
    .service-ind-main .cont-list .cont-tab a.on:after {
        transform: translateX(0);
        opacity: 1;
    }


    .cont-list .cont-item .cont-tab .cont-txt {

    }
    .cont-list .cont-item .cont-tab .cont-txt .sub-txt {

    }
    .cont-list .cont-item .cont-tab .cont-txt .sub-txt .in {
        border: 1px solid #f2f4f8;
        padding: 40px;
        margin-top: -1px;
        padding: 40px;
    }
    .service-ind-main .cont-list p {
        font-size: 15px;
        line-height: 26px;
        color: #777777;
    }
    .service-ind-main .cont-list .cont-txt img {
        max-width: 100%;
        object-fit: cover;
        display: block;
    }
    .cont-list .cont-item .cont-tab .cont-txt .cont-sub-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
    }
    .cont-list .cont-item .cont-tab .cont-txt .cont-sub-list .cont-sub-item {
        width: 31.3%;
        margin-top: 20px;
    }
    .cont-list .cont-item .cont-tab .cont-txt .cont-sub-list .cont-sub-item .icon {
        display: flex;
        height: 44px;
        align-items: flex-end;
    }
    .cont-list .cont-item .cont-tab .cont-txt .cont-sub-list .cont-sub-item .title {
        font-size: 17px;
        margin-top: 18px;
        color: #444444;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-weight: 500;
    }
    .cont-list .cont-item .cont-tab .cont-txt .cont-sub-list .cont-sub-item .content {
        margin-top: 20px;
    }
  </style>